const LOCKED_CARD_VARIANTS = [
  {
    id: "ai-pick",
    badge: "⭐ AI Pick",
    icon: 'fire.svg',
    title: "95% Viral Score",
    description: "This clip has strong viral potential.",
  },
  {
    id: "top-rated",
    badge: "🏆 Top Rated",
    icon: "top-rated.svg",
    title: "Perfect Retention Signal",
    description: "Built to keep viewers watching.",
  },
  {
    id: "trend-analysis",
    badge: "📈 Trend Analysis",
    icon: "trend-analysis.svg",
    title: "Trending Category",
    description: "Fits today's winning content trends.",
  },
  {
    id: "audience-match",
    badge: "💎 Audience Match",
    icon: "audience-match.svg",
    title: "Best for Your Audience",
    description: "Highly relevant to your viewers.",
  },
  {
    id: "ai-bets",
    badge: "👑 AI's Pick",
    icon: "ai-bets.svg",
    title: "AI Bets Big on This",
    description: "One of our strongest recommendations.",
  },
  {
    id: "pattern-match",
    badge: "📊 Pattern Match",
    icon: "pattern-match.svg",
    title: "Winning Framework",
    description: "Matches the structure of successful videos.",
  },
];

export const getLockedCardContent = (shortIdOrIndex) => {
  if (shortIdOrIndex === null || shortIdOrIndex === undefined) return LOCKED_CARD_VARIANTS[0];
  // Use index directly if it's a number (better distribution)
  // Otherwise use string hash for shortId
  let variantIndex;
  if (typeof shortIdOrIndex === "number") {
    variantIndex = shortIdOrIndex % LOCKED_CARD_VARIANTS.length;
  } else {
    // Hash string ID with better distribution
    let hash = 0;
    for (let i = 0; i < shortIdOrIndex.length; i++) {
      hash = (hash * 31 + shortIdOrIndex.charCodeAt(i)) % 1000000;
    }
    variantIndex = hash % LOCKED_CARD_VARIANTS.length;
  }
  return LOCKED_CARD_VARIANTS[variantIndex];
};

export default LOCKED_CARD_VARIANTS;
